import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import {
  CORP_CLIENT_LIST,
  POC_LIST,
  MEETING_SITES,
  CORP_CLIENT_EMAIL,
  MOM_LISTING,
  BA_OPPORTUNITY_FROM_LEADX
} from "./type";

// export const getCorpClientList = (siteId) => async (dispatch) => {
//   const res = await callWebService(
//     callTypes.get,
//     "",
//     `${Config.brandActivation.getCorporateClient}?site_id=${siteId}`
//   );
//   if (res) {
//     const { data } = res;
//     dispatch({ type: CORP_CLIENT_LIST, payload: data.response.data });
//     return data.response.data;
//   }
// };
export const getCorpClientList = (siteId,lat=null,lng=null,manageId=null) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.brandActivation.getCorporateClient}?site_id=${siteId}&latitude=${lat}&longitude=${lng}&manage_id=${manageId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: CORP_CLIENT_LIST, payload: data.response.data });
    return data.response.data;
  }
};

//CLIENT_EMAIL_FOR_MOM
export const getClientEmail = (siteId,meetingId) => async (dispatch) => { 
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.brandActivation.getEmailClient}?site_id=${siteId}&meeting_id=${meetingId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: CORP_CLIENT_EMAIL, payload: data.response.data });
    return data.response.data;
  }
};

//MOM_LISTING
export const getMomList = (meetingId) => async (dispatch) => { 
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.brandActivation.getMomList}?id=${meetingId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: MOM_LISTING, payload: data.response.data });
    return data.response.data;
  }
};

//SEND_MOM
export const createAndSendMom = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.brandActivation.meetingMomSend
  );
  if (res?.data?.response?.status === true) {
    return true;
  }
};

// MEETING_SITES

export const getCorpPocList = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.brandActivation.corporateClientPocList}?client_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: POC_LIST, payload: data.response.data });
    return data.response.data;
  }
};

export const postCorpClient = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.brandActivation.addCorporateClient
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else return false;
};

export const deleteCorpClient = (id) => async () => {
  const res = await callWebService(
    callTypes.delete,
    "",
    `${Config.brandActivation.deleteClient}?id=${id}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else return false;
};

export const updateCorpClient = (requestData) => async () => {
  const res = await callWebService(
    callTypes.put,
    requestData,
    Config.brandActivation.updateClient
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else return false;
};

export const getBaOpportunityFromLeadx = (siteId) => async (dispatch) => {
  const res = await callWebService(
      callTypes.get,
      "",
      `${Config.brandActivation.baOpportunityListFromLeadx}?site_id=${siteId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: BA_OPPORTUNITY_FROM_LEADX, payload: data.response.data });
    return data.response.data;
  }
};
